import { GameTypeEnum, VictoryPointDataController } from '@colonist/game-base-types';
import { CardDataController } from '@colonist/game-card-types';
import { ArrayUtils, ObjectUtils } from '@colonist/utils';
import { applyDiffs } from './GameStateDiffUtils.ts';
import { AccessLevel } from '@colonist/types';
export function filterEventHistoryForPerspectives(eventHistory, perspectives) {
    eventHistory.eventsPerspectives = perspectives;
    const filteredEvents = eventHistory.events.map((event)=>({
            input: event.input,
            stateChange: filterGameStateForPerspectives(event.stateChange, perspectives)
        }));
    const filteredNonEmptyEvents = filteredEvents.filter((event)=>!ObjectUtils.isNestedObjectEmpty(event.stateChange));
    return {
        ...eventHistory,
        initialState: filterGameStateForPerspectives(eventHistory.initialState, perspectives),
        events: filteredNonEmptyEvents
    };
}
export function filterGameStateForPerspectives(partialGameState, perspectives) {
    var _filteredGameState_mapState;
    const filteredGameState = structuredClone(partialGameState);
    for(const key in filteredGameState.playerStates){
        const playerColor = Number(key);
        const playerState = filteredGameState.playerStates[key];
        if (playerState == undefined) continue;
        filterPlayerStateForPerspectives(playerState, playerColor, perspectives);
    }
    if (filteredGameState.gameLogState !== undefined) filterGameLogsForPerspectives(filteredGameState.gameLogState, perspectives);
    if (filteredGameState.gameChatState !== undefined) filterGameChatForPerspectives(filteredGameState.gameChatState, perspectives);
    if (((_filteredGameState_mapState = filteredGameState.mapState) === null || _filteredGameState_mapState === void 0 ? void 0 : _filteredGameState_mapState.fogTileGroupStates) != undefined) filterFogTileState(filteredGameState.mapState.fogTileGroupStates);
    if (filteredGameState.mechanicSpecialBuildPhaseState != undefined) filterSpecialBuildPhaseStateForPlayers(filteredGameState.mechanicSpecialBuildPhaseState, perspectives);
    if (filteredGameState.mechanicDevelopmentCardsState != undefined) filterDevelopmentCardStateForRecipient(filteredGameState.mechanicDevelopmentCardsState, perspectives);
    if (filteredGameState.mechanicProgressCardsState != undefined) filterProgressCardStateForRecipient(filteredGameState.mechanicProgressCardsState, perspectives);
    return filteredGameState;
}
export function filterPlayerStateForPerspectives(playerState, playerStateColor, perspectives) {
    var _playerState_resourceCards;
    if (perspectives.includes(playerStateColor)) return playerState;
    if (playerState.victoryPointsState !== undefined) filterVictoryPointStateMakePrivate(playerState.victoryPointsState);
    if (((_playerState_resourceCards = playerState.resourceCards) === null || _playerState_resourceCards === void 0 ? void 0 : _playerState_resourceCards.cards) !== undefined) playerState.resourceCards.cards = CardDataController.getCardBacksForCards(playerState.resourceCards.cards);
    return playerState;
}
function filterVictoryPointStateMakePrivate(victoryPointState) {
    for (const victoryPointType of Object.keys(victoryPointState)){
        const victoryPointData = VictoryPointDataController.getVictoryPointByType(Number(victoryPointType));
        if (victoryPointData == undefined) continue;
        if (victoryPointData.private) delete victoryPointState[victoryPointType];
    }
}
export function getCurrentGameState(gameEventHistory) {
    const currentState = structuredClone(gameEventHistory.initialState);
    for (const gameEvent of gameEventHistory.events){
        applyDiffs(currentState, [
            gameEvent.stateChange
        ]);
    }
    return currentState;
}
export function filterGameLogsForPerspectives(gameLogState, perspectives) {
    const isSpectator = perspectives.length === 0;
    if (isSpectator) {
        filterGameLogsForSpectators(gameLogState);
    } else {
        filterGameLogsForPlayers(gameLogState, perspectives);
    }
}
function filterGameLogsForSpectators(gameLogState) {
    for(const gameLogIndex in gameLogState){
        const gameLogData = gameLogState[gameLogIndex];
        if (gameLogData == undefined) continue;
        const sendToSpectators = gameLogData.toSpectators != false;
        if (sendToSpectators) continue;
        delete gameLogState[gameLogIndex];
    }
}
function filterGameLogsForPlayers(gameLogState, perspectives) {
    for(const gameLogIndex in gameLogState){
        const gameLogData = gameLogState[gameLogIndex];
        if (gameLogData == undefined) continue;
        if (gameLogData.specificRecipients == undefined) continue;
        if (ArrayUtils.isSomeElementIncluded(gameLogData.specificRecipients, perspectives)) continue;
        delete gameLogState[gameLogIndex];
    }
}
export function filterGameChatForPerspectives(gameChatState, perspectives) {
    const isSpectator = perspectives.length === 0;
    if (isSpectator) {
        filterGameChatsForSpectators(gameChatState);
    } else {
        filterGameChatsForPlayers(gameChatState, perspectives);
    }
}
function filterGameChatsForSpectators(gameChatState) {
    for(const gameChatIndex in gameChatState){
        const gameChatData = gameChatState[gameChatIndex];
        if (gameChatData == undefined) continue;
        const sendToSpectator = gameChatData.toSpectators != false;
        if (sendToSpectator) continue;
        delete gameChatState[gameChatIndex];
    }
}
function filterGameChatsForPlayers(gameChatState, perspectives) {
    for(const gameChatIndex in gameChatState){
        const gameChatData = gameChatState[gameChatIndex];
        if (gameChatData == undefined) continue;
        if (gameChatData.recipients == undefined) continue;
        if (ArrayUtils.isSomeElementIncluded(gameChatData.recipients, perspectives)) continue;
        delete gameChatState[gameChatIndex];
    }
}
function filterFogTileState(fogTileStates) {
    for(const fogTileGroupKey in fogTileStates){
        const fogTileState = fogTileStates[fogTileGroupKey];
        if (fogTileState == undefined) continue;
        delete fogTileState.possibleDiceNumbers;
        delete fogTileState.possibleTileTypes;
    }
}
function filterSpecialBuildPhaseStateForPlayers(specialBuildPhaseState, perspectives) {
    if (specialBuildPhaseState.playerStates == undefined) return;
    for(const playerStateKey in specialBuildPhaseState.playerStates){
        const playerColor = Number(playerStateKey);
        const playerState = specialBuildPhaseState.playerStates[playerColor];
        if (playerState == undefined) continue;
        if (perspectives.includes(playerColor)) continue;
        delete playerState.isRequesting;
    }
}
export function filterDevelopmentCardStateForRecipient(developmentCardState, perspectives) {
    var _developmentCardState_bankDevelopmentCards;
    if (((_developmentCardState_bankDevelopmentCards = developmentCardState.bankDevelopmentCards) === null || _developmentCardState_bankDevelopmentCards === void 0 ? void 0 : _developmentCardState_bankDevelopmentCards.cards) != undefined) developmentCardState.bankDevelopmentCards.cards = CardDataController.getCardBacksForCards(developmentCardState.bankDevelopmentCards.cards);
    for(const playerColorKey in developmentCardState.players){
        var _playerDevelopmentCardState_developmentCards;
        const playerColor = Number(playerColorKey);
        if (perspectives.includes(playerColor)) continue;
        const playerDevelopmentCardState = developmentCardState.players[playerColor];
        if (playerDevelopmentCardState == undefined) continue;
        if (((_playerDevelopmentCardState_developmentCards = playerDevelopmentCardState.developmentCards) === null || _playerDevelopmentCardState_developmentCards === void 0 ? void 0 : _playerDevelopmentCardState_developmentCards.cards) != undefined) playerDevelopmentCardState.developmentCards.cards = CardDataController.getCardBacksForCards(playerDevelopmentCardState.developmentCards.cards);
        if (playerDevelopmentCardState.developmentCardsBoughtThisTurn != undefined) delete playerDevelopmentCardState.developmentCardsBoughtThisTurn;
    }
}
export function filterProgressCardStateForRecipient(progressCardState, perspectives) {
    var _progressCardState_bankProgressCards;
    if (((_progressCardState_bankProgressCards = progressCardState.bankProgressCards) === null || _progressCardState_bankProgressCards === void 0 ? void 0 : _progressCardState_bankProgressCards.cards) != undefined) progressCardState.bankProgressCards.cards = CardDataController.getCardBacksForCards(progressCardState.bankProgressCards.cards);
    for(const playerColorKey in progressCardState.players){
        var _playerProgressCardState_progressCards;
        const playerColor = Number(playerColorKey);
        if (perspectives.includes(playerColor)) continue;
        const playerProgressCardState = progressCardState.players[playerColor];
        if (playerProgressCardState == undefined) continue;
        if (((_playerProgressCardState_progressCards = playerProgressCardState.progressCards) === null || _playerProgressCardState_progressCards === void 0 ? void 0 : _playerProgressCardState_progressCards.cards) != undefined) playerProgressCardState.progressCards.cards = CardDataController.getCardBacksForCards(playerProgressCardState.progressCards.cards);
    }
}
export function getAllowedPerspectivesForUser(allPlayerColors, playersColorsControlledByUser, replayInitialPerspective, userId, userMembership, gameTypeId, accessLevel) {
    if (canAccessReplayDataThroughSpecialPermissions(gameTypeId, accessLevel)) return allPlayerColors;
    if (userId === undefined) return [
        replayInitialPerspective
    ];
    if (userMembership === undefined) return ArrayUtils.getUniqueElements([
        replayInitialPerspective,
        ...playersColorsControlledByUser
    ]);
    return allPlayerColors;
}
export function canAccessReplayDataThroughSpecialPermissions(gameTypeId, accessLevel) {
    if (gameTypeId == GameTypeEnum.CreatedTournamentRoom) return true;
    const validAccessLevels = [
        AccessLevel.Administrator,
        AccessLevel.Manager,
        AccessLevel.Moderator
    ];
    if (accessLevel != undefined && validAccessLevels.includes(accessLevel)) return true;
    return false;
}
